export interface RGBColor {
  red: number;
  green: number;
  blue: number;
}

export interface RGBAColor extends RGBColor {
  alpha: number;
}

export const rgbToString = (color: RGBColor) => {
  const { red, green, blue } = color;
  const array = [red, green, blue];
  if ('alpha' in color) {
    const alpha = color as RGBAColor;
    array.push(alpha.alpha);
  }
  return array.join(',');
};

const modifyHex = (hex: string) => {
  if (hex.length === 4) {
    hex = hex.replace('#', '');
  }
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  return hex;
};

export const hexToRgb = (hex: string) => {
  hex = hex.replace('#', '');
  if (hex.length !== 6) {
    hex = modifyHex(hex);
  }

  const color: RGBColor = {
    red: parseInt(hex.slice(0, 2), 16),
    green: parseInt(hex.slice(2, 4), 16),
    blue: parseInt(hex.slice(4, 6), 16),
  };

  return color;
};

export const rgbToHex = (rgb: string) => {
  const y = rgb.match(/\d+/g)?.map((x) => {
    return parseInt(x, 10).toString(16).padStart(2, '0');
  });
  return y?.join('').toUpperCase();
};
